import { DeleteOutlined, FormOutlined } from '@ant-design/icons';
import { makeStyles } from '@material-ui/core';
import { Badge, Button, Popconfirm, Space, Table } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { JobStatus } from '../components';


const useStyles = makeStyles(theme => ({
    table: {
        width: '100%',
        height: '100%',
        marginRight: theme.spacing(1)
    },
}))

/**
 * uploads Table view
 */
const UploadsTableView = ({ uploads, loading,  deleteUploads, count, updateLimit, updatePage, page, limit, retryJob, setOrdering, onSelectTool }) => {
    const classes = useStyles()

    const [typeFilters, setTypeFilters] = useState([])
    const [statusFilters, setStatusFilters] = useState([])

    useEffect(() => {
        // extract the unique creator names from uploads
        if (uploads) {
            const types = [...new Set(uploads.map(j => j.type))]
            setTypeFilters(types.map(n => ({ text: n, value: n })))

            const status = [...new Set(uploads.map(j => j.status))]
            setStatusFilters(status.map(n => ({ text: n, value: n })))

        }
    }, [uploads])



    // uploads table schema
    const uploadsViewSchema = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            sorter: (a, b) => a - b,
            render: (text, record) => <Button type="text" size="small">{text}</Button>
        },
        {
            title: 'File',
            dataIndex: 'file_name',
            key: 'file_name',
            sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
            render: (text, record) =>
                <span className={classes.nameCell}>{text}</span>
        },

        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            filters: typeFilters,
            onFilter: (value, record) => record.type.indexOf(value) === 0
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            filters: statusFilters,
            sorter: (a, b) => a.status.localeCompare(b.status),
            render: (text, _) => <JobStatus status={text} />,
            onFilter: (value, record) => record.status.indexOf(value) === 0
        },

        {
            title: 'Updated Date',
            dataIndex: 'updated_at',
            key: 'updated_at',
            render: updated_at => (moment(updated_at).format("YYYY-MM-DD HH:mm")),
        },

        {
            title: 'Created Date',
            dataIndex: 'created_at',
            key: 'created_at',
            render: created_at => (
                moment(created_at).format("YYYY-MM-DD HH:mm"))
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => {

                return (
                    <Space>

                        
                    </Space>
                );
            }
        }

    ]

    const changePage = (page, _) => {
        updatePage(page);
    }

    const changeSize = (page, size) => {
        updateLimit(size)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        const field = sorter.field;
        const order = sorter.order;

        if (field && order) {
            const ordering = order === "descend" ? `-${field}` : field;
            setOrdering(ordering);
        }
    }


    return <Table
        columns={uploadsViewSchema}
        size='small'
        dataSource={uploads}
        className={classes.table}
        loading={loading}
        onChange={handleTableChange}
        pagination={{
            onChange: changePage,
            onShowSizeChange: changeSize,
            showSizeChanger: true,
            total: count,
            current: page,
            pageSize: limit,
        }}
    />
}

UploadsTableView.propTypes = {
    /** List of fetched uploads */
    uploads: PropTypes.array,
    /** Callback for job selection */
    /** Show edit cookie drawer */
    /** Callback for job selection */
    /** Control table loader */
    loading: PropTypes.bool
}

export default UploadsTableView
